module.exports = __webpack_public_path__ + "static/media/detail_title_tick.c3c33302.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/detail_title_tick.png
// module id = 1970
// module chunks = 6